import React, { useState } from 'react';
import { faEnvelope, faTrash } from '@fortawesome/free-solid-svg-icons';
import DashItemMenu from 'components/DashItemMenu';

import { Button } from '@shoflo/polymer/components/Button/Button';
import InlineConfirmation from 'components/InlineConfirmation';
const CrewListItemMenu = ({ onDelete, onResend, showResend, showRemove }) => {
  const [showRemoveConfirmation, setShowRemoveConfirmation] = useState(false);

  const items = [];

  if (showResend) {
    items.push({
      onClick: onResend,
      icon: faEnvelope,
      title: ' Resend',
    });
  }

  if (showRemove) {
    items.push({
      onClick: onDelete,
      icon: faTrash,
      title: ' Remove',
    });
  }

  if (!showResend && showRemove) {
    return !showRemoveConfirmation ? (
      <Button
        color="secondary"
        variant="outlined"
        onClick={() => setShowRemoveConfirmation(true)}
      >
        Remove
      </Button>
    ) : (
      <InlineConfirmation
        onConfirm={() => {
          onDelete();
          setShowRemoveConfirmation(false);
        }}
        onCancel={() => {
          setShowRemoveConfirmation(false);
        }}
      />
    );
  }

  return <DashItemMenu items={items} />;
};

export default CrewListItemMenu;
